import './titleCard.scss';

import { ReactNode } from 'react';

interface IProps {
  title: string;
  children: ReactNode;
  height?: number | string;
}

function TitleCard({ title, children, height }: IProps) {
  return (
    <div className='title_card_wrapper' style={{ height: height || 'auto' }}>
      <div className='title_card_title'>{title}</div>
      {children}
    </div>
  );
}

export default TitleCard;
